/*
	Client-side environment access.

	Only PUBLIC_* variables are exposed to the browser, and each is referenced
	*statically* below (`process.env.PUBLIC_X`, never bare `process.env` or a computed
	`process.env[key]`). That is deliberate and load-bearing:

	  - A bare/dynamic `process.env` makes the bundler inline the WHOLE environment into
	    the client bundle — leaking non-public values (DB credentials, etc.).
	  - It also forces a runtime `process.env` shim, which prevents the bundler baking in
	    NODE_ENV=production — silently dropping React into its larger, slower development
	    build (dev warnings, `scheduler.development`).

	The bundler's EnvironmentPlugin replaces each static reference here with its literal
	value at build time, so `process` is never referenced at runtime. Add a variable to
	the map to expose it; nothing outside the map can reach the client.
*/
const PUBLIC_ENV: Record<string, string | undefined> = {
	PUBLIC_DUMP_ALLOWED: process.env.PUBLIC_DUMP_ALLOWED,
	PUBLIC_SITE_NAME: process.env.PUBLIC_SITE_NAME,
	PUBLIC_MEMBER_LOGIN_URL: process.env.PUBLIC_MEMBER_LOGIN_URL,
	PUBLIC_MEMBER_REGISTRATION_URL: process.env.PUBLIC_MEMBER_REGISTRATION_URL,
	PUBLIC_DEBIT_TEST_ACCOUNT_NUMBER: process.env.PUBLIC_DEBIT_TEST_ACCOUNT_NUMBER,
	PUBLIC_DEBIT_TEST_SORT_CODE: process.env.PUBLIC_DEBIT_TEST_SORT_CODE,
};

export function getEnv(variable: string): string | null {
	return PUBLIC_ENV[variable] ?? null;
}

export function hasEnv(variable: string): boolean {
	const value = PUBLIC_ENV[variable];
	return value != null && value !== '';
}

/*
	The React checkout bundle is never the Astro-rendered context, so this is always
	false. Kept as a stub so callers that guard against Astro keep compiling without a
	change; do not reintroduce a bare `import.meta.env` read here — see the note above.
*/
export function hasAstroEnv(_variable: string): boolean {
	return false;
}
